import React, { useState, useContext, useEffect, useCallback } from "react";
import "../../styles/pages/login/Login.scss";
import { CryptoPassword } from "../../components/CryptoPassword";
import { jwtLogin } from "../../api/apiManagement";
import { GlobalContext } from "../../App";
import { useNavigate } from "react-router-dom";
import Counter from "../../components/Counter";
function Login() {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({ login: "", password: "" });
  const [canLogin, setCanLogin] = useState(false);
  const [error, setError] = useState(false);
  const { setIsLoading, isLogin, setIsLogin } = useContext(GlobalContext);

  useEffect(() => {
    if (
      loginData.login !== "" &&
      loginData.password !== "" &&
      loginData.password !==
        "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470"
    ) {
      setCanLogin(true);
    } else {
      setCanLogin(false);
    }
  }, [loginData.login, loginData.password]);

  function handleLogin() {
    setIsLoading(true);

    jwtLogin(loginData)
      .then((res) => {
        const currentStatusCode = res.data.status;

        if (currentStatusCode === 200) {
          localStorage.setItem("jwt", atob(res.data.jwt_content.signature));
          localStorage.setItem("user_data", atob(res.data.jwt_content.payload));
          setError(false);
          setIsLogin(true);
        }

        if (currentStatusCode === 500) {
          setError(true);
        }

        if (currentStatusCode === 601) {
          setError(true);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setIsLoading(false);
      });
  }
  // const JWT = JSON.parse(localStorage.getItem("jwt"))?.signature;
  // if (isLogin) {
  //   ({ sua_id, first_name, last_name, email, phone } = JSON.parse(
  //     localStorage.getItem("user_data")
  //   ));
  // }
  return (
    <div className="login-container">
      {isLogin ? (
        <>
          <div className="logined-container">
            <div className="logined-text">你已經登入ClubS會員</div>
            <div className="cooldown">
              <Counter
                defalutCount={5}
                isCooldown={true}
                toZero={() => navigate("/")}
              />
              秒後返回首頁
            </div>
            <button className="login-button" onClick={() => navigate("/")}>
              返回
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="title">
            <b className="clubs-title">ClubS</b> 會員登入
          </div>
          <div className="input-container">
            <span className="input-label">電郵</span>
            <input
              className="input-box"
              onChange={(e) =>
                setLoginData((prev) => ({
                  ...prev,
                  login: e.target.value,
                }))
              }
            ></input>
          </div>
          <div className="input-container">
            <span className="input-label">密碼</span>
            <input
              className="input-box"
              type="password"
              onChange={(e) =>
                setLoginData((prev) => ({
                  ...prev,
                  password: CryptoPassword(e.target.value),
                }))
              }
            ></input>
          </div>

          <div className="error"> {error ? <>error</> : <></>}</div>
          <button
            className={canLogin ? "login-button" : "cant-login-button"}
            onClick={handleLogin}
            disabled={!canLogin}
          >
            登入
          </button>
        </>
      )}
    </div>
  );
}

export default Login;
